import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { IconModule } from '../icon/icon.module';
import { TruncateModule } from '../truncate/truncate.module';
import { BaseButtonDirective } from './base-button';
import { AddNewButtonComponent } from './components/add-new-button/add-new-button.component';
import { ButtonNewComponent } from './components/button/button.comonent';
import { IconButtonComponent } from './components/icon-button/icon-button.component';
import { PlanButtonComponent } from './components/plan-button/plan-button.component';
import { ButtonDropdownIndicatorDirective } from './directives/button-dropdown/button-dropdown-indicator.directive';
import { ButtonLoadingDirective } from './directives/button-loading/button-loading.directive';

@NgModule({
  imports: [IconModule, TruncateModule, CommonModule, I18nModule],
  declarations: [
    ButtonNewComponent,
    ButtonDropdownIndicatorDirective,
    ButtonLoadingDirective,
    IconButtonComponent,
    BaseButtonDirective,
    PlanButtonComponent,
    AddNewButtonComponent,
  ],
  exports: [
    ButtonNewComponent,
    ButtonDropdownIndicatorDirective,
    ButtonLoadingDirective,
    IconButtonComponent,
    PlanButtonComponent,
    AddNewButtonComponent,
  ],
})
export class ButtonNewModule {}
export {
  ButtonNewComponent,
  ButtonDropdownIndicatorDirective,
  ButtonLoadingDirective,
  IconButtonComponent,
  BaseButtonDirective,
  PlanButtonComponent,
  AddNewButtonComponent,
};
